<template>
  <div>
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div
        class="mx-2 w-full max-w-2xl max-h-full bg-white shadow-lg rounded-lg overflow-auto px-4"
      >
        <div class="flex flex-col sticky top-0 bg-white pt-5 z-50">
          <div class="absolute right-0">
            <button
              aria-label="close"
              class="text-xl text-gray-500"
              @click.prevent="close"
            >
              ×
            </button>
          </div>
          <div
            class="w-full text-center px-3 text-purple-700 text-2xl font-bold"
          >
            <span>{{ levantamientoInfo.nombre }}</span>
          </div>
          <div
            class="w-full text-center px-3 pb-3 text-1xl font-bold"
            v-bind:style="{ color: levantamientoInfo.cat_color }"
          >
            <span>{{ levantamientoInfo.cat_principal }}</span>
          </div>
        </div>

        <div
          class="flex w-full justify-center items-center pb-3"
          v-if="levantamientoInfo.ubicacion_sensible"
        >
          <template v-if="mediaArray[0].mimeType.includes('image')">
            <span
              v-if="mediaArray.length > 1"
              class="flex items-center justify-center bg-gray-900 bg-opacity-50 text-white cursor-pointer"
              @click="slideToLeft()"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="fill-current"
                height="48"
                width="48"
              >
                <path
                  d="M28.05 36 16 23.95 28.05 11.9 30.2 14.05 20.3 23.95 30.2 33.85Z"
                />
              </svg>
            </span>
            <div class="px-4 h-64">
              <img
                id="imageLev"
                :src="replaceURL(mediaArray[0].fileName)"
                class="h-full w-full object-contain"
              />
            </div>
            <span
              v-if="mediaArray.length > 1"
              class="flex items-center justify-center bg-gray-900 bg-opacity-50 text-white cursor-pointer"
              @click="slideToRight()"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="fill-current"
                height="48"
                width="48"
              >
                <path
                  d="M18.75 36 16.6 33.85 26.5 23.95 16.6 14.05 18.75 11.9 30.8 23.95Z"
                />
              </svg>
            </span>
          </template>
          <template v-else>
            <div class="px-4 h-64">
              <video
                id="videoLev"
                :src="replaceURL(mediaArray[0].fileName)"
                class="h-full w-full bg-gray-300"
                controls
              ></video>
            </div>
          </template>
        </div>

        <div class="flex flex-wrap">
          <div class="flex flex-col w-full">
            <form
              class="w-full max-w-2xl"
              id="levantamientoForm"
              @submit.prevent
            >
              <div v-if="showFormView" class="px-5">
                <div class="flex flex-wrap -mx-3 pb-3">
                  <!-- Ficha de información-->
                  <div
                    class="w-full"
                    v-for="one_question in currentQuestions"
                    :key="one_question.id"
                  >
                    <div v-if="one_question.texto != null">
                      <label
                        class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                        >{{ one_question.id_pregunta }}.-
                        {{ one_question.texto }}</label
                      >

                      <!-- TEMPLATE PARA PREGUNTAS DE TIPO ABIERTAS -->
                      <div v-if="one_question.tipo === 'ABIERTA'">
                       <!--  <span v-if="one_question.sensible === true">
                          Esta información es sensible
                        </span> -->
                        <div
                          v-if="
                            one_question.sensible === false ||
                            ((user_id === levantamientoInfo.usuario_id ||
                              category_id === 'ADMINISTRADOR') &&
                              one_question.sensible === true)
                          "
                        >

                          <textarea
                            v-if="one_question.tipo === 'ABIERTA'"
                            class="textareaficha appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            type="text"
                            name="question"
                            :value="one_question.respuesta"
                            disabled
                          />
                        </div>

                        <div
                          v-if="
                            one_question.sensible === true &&
                            user_id !== levantamientoInfo.usuario_id &&
                            category_id !== 'ADMINISTRADOR'
                          "
                          style="filter: blur(4px)"
                        >
                          <input
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            type="text"
                            name="question"
                            value=""
                            disabled
                          />
                        </div>
                      </div>
                      <!-- TEMPLATE PARA PREGUNTAS DE TIPO ABIERTAS -->

                      <!-- TEMPLATE PARA PREGUNTAS DE TIPO MULTISELECCION -->
                      <div v-else-if="one_question.tipo === 'MULTISELECCION'">
                        <template v-for="(id_key, answer) in one_question.respuesta.opciones">
                          <input
                            v-if="id_key === true"
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            type="text"
                            name="question"
                            :value="answer"
                            disabled
                          />
                        </template>

                        <div v-if="one_question.respuesta.otro !=null && one_question.respuesta.otro !='' " class="flex items-left text-gray-700 font-bold" style="align-items:baseline">
                          Otro: &nbsp; &nbsp; 
                          <input 
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            type="text"
                            name="question"
                            :value="one_question.respuesta.otro"
                            disabled
                          />
                        </div>                         

                        <template
                      v-if="one_question.respuesta.hasOwnProperty('subpregunta')"
                    >
                      <template v-for="(answer, index) in one_question.respuesta.subpregunta">
                        <label
                          class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                          >{{ answer.id_pregunta }}.-
                          {{ answer.texto }}</label
                        >
                        
                        <template v-if="answer.tipo == 'SELECCION'">  
                          <template v-if="answer.respuesta.selected_answer != 'Otro'">
                            <input
                              class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              type="text"
                              name="question"
                              :value="answer.respuesta.selected_answer"
                              disabled
                            />
                          </template> 

                          <template v-else>
                            <input
                              class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              type="text"
                              name="question"
                              :value="answer.respuesta.selected_answer + ' ' +answer.respuesta.otro"
                              disabled
                            />
                          </template> 
                        </template> 

                        <template v-if="answer.tipo == 'ABIERTA'">  
                          <textarea
                            class="textareaficha appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            type="text"
                            name="question"
                            :value="answer.respuesta"
                            disabled
                          />
                        </template> 

                        <template v-if="answer.tipo == 'CAMPOS'">  
                          <template v-for="(id_key, label) in answer.respuesta">  
                            <div class="flex w-full items-center justify-center">
                              <label
                                class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                                >{{ label }}</label
                              >
                              <input
                                class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                type="text"
                                name="question"
                                :value="id_key"
                                disabled
                              />
                            </div>
                          </template> 
                        </template> 
                      </template>
                    </template>
                      </div>
                      <!-- /TEMPLATE PARA PREGUNTAS DE TIPO MULTISELECCION -->

                      <!-- TEMPLATE PARA PREGUNTAS DE TIPO SELECCION_CONDICIONAL -->
                      <div v-else-if="one_question.tipo === 'SELECCION_CONDICIONAL'">
                        <input
                          class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                          type="text"
                          name="question"
                          :value="one_question.respuesta.selected_answer"
                          disabled
                        />

                        <template
                          v-if="
                            one_question.respuesta.conditional_answer.hasOwnProperty(one_question.respuesta.selected_answer)"
                        >
                          <label
                            class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                            >{{ one_question.respuesta.conditional_answer[one_question.respuesta.selected_answer].id }}.-
                            {{ one_question.respuesta.conditional_answer[one_question.respuesta.selected_answer].texto}}</label
                          >

                          <template v-if="one_question.respuesta.conditional_answer[one_question.respuesta.selected_answer].tipo == 'ABIERTA'">

                            <template
                              v-if="
                                one_question.respuesta.conditional_answer[
                                  one_question.respuesta.selected_answer
                                ].sensible === false ||
                                ((user_id === levantamientoInfo.usuario_id ||
                                  category_id === 'ADMINISTRADOR') &&
                                  one_question.respuesta.conditional_answer[
                                    one_question.respuesta.selected_answer
                                  ].sensible === true)
                              "
                            >
                              <textarea
                                class="textareaficha appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                type="text"
                                name="question"
                                :value="one_question.respuesta.conditional_answer[one_question.respuesta.selected_answer].respuesta"
                                disabled
                              />
                            </template>

                            <template
                              v-if="
                                one_question.respuesta.conditional_answer[
                                  one_question.respuesta.selected_answer
                                ].sensible === true &&
                                user_id !== levantamientoInfo.usuario_id &&
                                category_id !== 'ADMINISTRADOR'
                              "
                            >
                              <input
                                style="filter: blur(4px)"
                                class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                type="text"
                                name="question"
                                value=""
                                disabled
                              />
                            </template>

                            <template v-if="one_question.respuesta.conditional_answer[one_question.respuesta.selected_answer].hasOwnProperty('subpregunta')">
                              <template v-for="(subquestion, subIndex) in one_question.respuesta.conditional_answer[one_question.respuesta.selected_answer].subpregunta">
                                <label class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left" :key="'subQ' + subIndex">
                                  {{ subquestion.id_pregunta }}.-
                                  {{ subquestion.texto }}
                                </label>

                                <template v-if="subquestion.tipo == 'SELECCION'">
                                  <input
                                    class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                    type="text"
                                    name="question"
                                    :value="subquestion.respuesta"
                                    :key="'subA' + subIndex"
                                    disabled
                                  />
                                </template>
                              </template>
                            </template>

                          </template>

                          <template v-if="one_question.respuesta.conditional_answer[one_question.respuesta.selected_answer].tipo == 'MULTISELECCION'">
                            <template v-for="(id_key, answer) in one_question.respuesta.conditional_answer[one_question.respuesta.selected_answer].respuesta.opciones">
                              <input
                                v-if="id_key === true"
                                class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                type="text"
                                name="question"
                                :value="answer"
                                disabled
                              />
                            </template>

                            <template v-if="one_question.respuesta.conditional_answer[one_question.respuesta.selected_answer].respuesta.otro != ''">  
                              <input
                                class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                type="text"
                                name="question"
                                :value="'Otro:' + ' ' +one_question.respuesta.conditional_answer[one_question.respuesta.selected_answer].respuesta.otro"
                                disabled
                              />
                            </template>
                          </template>

                          <template v-if="one_question.respuesta.conditional_answer[one_question.respuesta.selected_answer].tipo == 'SELECCION'">
                            <input
                              class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              type="text"
                              name="question"
                              :value="one_question.respuesta.conditional_answer[one_question.respuesta.selected_answer].respuesta"
                              disabled
                            />
                          </template>

                          <template
                            v-if="
                              one_question.respuesta.conditional_answer[
                                one_question.respuesta.selected_answer
                              ].tipo === 'CAMPOS'
                            "
                          >
                            <template
                              v-if="
                                one_question.respuesta.conditional_answer[
                                  one_question.respuesta.selected_answer
                                ].sensible === false ||
                                ((user_id === levantamientoInfo.usuario_id ||
                                  category_id === 'ADMINISTRADOR') &&
                                  one_question.respuesta.conditional_answer[
                                    one_question.respuesta.selected_answer
                                  ].sensible === true)
                              "
                            >
                              <template
                                v-for="(id_key, answer) in one_question
                                  .respuesta.conditional_answer[
                                  one_question.respuesta.selected_answer
                                ].respuesta"
                              >
                                <div
                                  class="flex w-full items-center justify-center"
                                >
                                  <label
                                    class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                                    >{{ answer }}</label
                                  >
                                  <input
                                    class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                    type="text"
                                    name="question"
                                    :value="id_key"
                                    disabled
                                  />
                                </div>
                              </template>
                            </template>

                            <template
                              v-if="
                                one_question.respuesta.conditional_answer[
                                  one_question.respuesta.selected_answer
                                ].sensible === true &&
                                user_id !== levantamientoInfo.usuario_id &&
                                category_id !== 'ADMINISTRADOR'
                              "
                            >
                              <template
                                v-for="(id_key, answer) in one_question
                                  .respuesta.conditional_answer[
                                  one_question.respuesta.selected_answer
                                ].respuesta"
                              >
                                <div
                                  class="flex w-full items-center justify-center"
                                >
                                  <label
                                    class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                                    >{{ answer }}</label
                                  >
                                  <input
                                    style="filter: blur(4px)"
                                    class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                    type="text"
                                    name="question"
                                    value=""
                                    disabled
                                  />
                                </div>
                              </template>
                            </template>
                          </template>
                        </template>

                      </div>
                      <!-- /TEMPLATE PARA PREGUNTAS DE TIPO SELECCION_CONDICIONAL -->

                      <!-- TEMPLATE PARA PREGUNTAS DE TIPO SELECCION -->
                      <div v-else-if="one_question.tipo === 'SELECCION'">
                        <template v-if="one_question.respuesta.selected_answer != 'Otro'"> 
                          <input
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            type="text"
                            name="question"
                            :value="one_question.respuesta.selected_answer"
                            disabled
                          />
                        </template>
                        <template v-else>
                          <input
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            type="text"
                            name="question"
                            :value="one_question.respuesta.selected_answer + ': ' +one_question.respuesta.otro"
                            disabled
                          />
                        </template> 

                        <template
                          v-if="one_question.respuesta.hasOwnProperty('subpregunta')"
                        >
                          <template v-for="(answer, index) in one_question.respuesta.subpregunta">
                            <label
                              class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                              >{{ answer.id_pregunta }}.-
                              {{ answer.texto }}</label
                            >

                            <template v-if="answer.tipo == 'SELECCION'">  
                              <template v-if="answer.respuesta.selected_answer != 'Otro'">
                                <input
                                  class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                  type="text"
                                  name="question"
                                  :value="answer.respuesta.selected_answer"
                                  disabled
                                />
                              </template> 

                              <template v-else>
                                <input
                                  class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                  type="text"
                                  name="question"
                                  :value="answer.respuesta.selected_answer + ': ' +answer.respuesta.otro"
                                  disabled
                                />
                              </template> 
                            </template> 

                            <template v-if="answer.tipo == 'ABIERTA'">
                             <!--  <span v-if="answer.sensible === true">
                                Esta información es sensible
                              </span> -->
                              <template
                                v-if="
                                  answer.sensible === false ||
                                  ((user_id === levantamientoInfo.usuario_id ||
                                    category_id === 'ADMINISTRADOR') &&
                                    answer.sensible === true)
                                "
                              >
                                <textarea
                                  class="textareaficha appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                  type="text"
                                  name="question"
                                  :value="answer.respuesta"
                                  disabled
                                />
                              </template>

                              <template
                                v-if="
                                  answer.sensible === true &&
                                  user_id !== levantamientoInfo.usuario_id &&
                                  category_id !== 'ADMINISTRADOR'
                                "
                              >
                                <input
                                  style="filter: blur(4px)"
                                  class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                  type="text"
                                  name="question"
                                  value=""
                                  disabled
                                />
                              </template>
                            </template>

                            <template v-if="answer.tipo == 'CAMPOS'">
                             <!--  <span v-if="answer.sensible === true">
                                Esta información es sensible
                              </span> -->
                              <template
                                v-if="
                                  answer.sensible === false ||
                                  ((user_id === levantamientoInfo.usuario_id ||
                                    category_id === 'ADMINISTRADOR') &&
                                    answer.sensible === true)
                                "
                              >
                                <template
                                  v-for="(id_key, label) in answer.respuesta"
                                >
                                  <div
                                    class="flex w-full items-center justify-center"
                                  >
                                    <label
                                      class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                                      >{{ label }}</label
                                    >
                                    <input
                                      class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                      type="text"
                                      name="question"
                                      :value="id_key"
                                      disabled
                                    />
                                  </div>
                                </template>
                              </template>

                              <template
                                v-if="
                                  answer.sensible === true &&
                                  user_id !== levantamientoInfo.usuario_id &&
                                  category_id !== 'ADMINISTRADOR'
                                "
                              >
                                <template
                                  v-for="(id_key, label) in answer.respuesta"
                                >
                                  <div
                                    class="flex w-full items-center justify-center"
                                  >
                                    <label
                                      class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                                      >{{ label }}</label
                                    >
                                    <input
                                      style="filter: blur(4px)"
                                      class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                      type="text"
                                      name="question"
                                      value=""
                                      disabled
                                    />
                                  </div>
                                </template>
                              </template>
                            </template>

                          </template>
                        </template>
                      </div>
                      <!-- /TEMPLATE PARA PREGUNTAS DE TIPO SELECCION -->

                      <div v-else-if="one_question.tipo === 'CAMPOS' || one_question.tipo === 'MINI_FORMULARIO'">
                       <!--  <span v-if="one_question.sensible === true">
                          Esta información es sensible
                        </span> -->
                        <template
                          v-if="
                            one_question.sensible === false ||
                            ((user_id === levantamientoInfo.usuario_id ||
                              category_id === 'ADMINISTRADOR') &&
                              one_question.sensible === true)
                          "
                        >
                          <template
                            v-for="(id_key, answer) in one_question.respuesta"
                          >
                            <div
                              class="flex w-full items-center justify-center"
                            >
                              <label
                                class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                                >{{ answer }}</label
                              >
                              <input
                                class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                type="text"
                                name="question"
                                :value="id_key"
                                disabled
                              />
                            </div>
                          </template>
                        </template>

                        <template
                          v-if="
                            one_question.sensible === true &&
                            user_id !== levantamientoInfo.usuario_id &&
                            category_id !== 'ADMINISTRADOR'
                          "
                        >
                          <template
                            v-for="(id_key, answer) in one_question.respuesta"
                          >
                            <div
                              class="flex w-full items-center justify-center"
                            >
                              <label
                                class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                                >{{ answer }}</label
                              >
                              <input
                                style="filter: blur(4px)"
                                class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                type="text"
                                name="question"
                                value=""
                                disabled
                              />
                            </div>
                          </template>
                        </template>
                      </div>
                      <!-- /TEMPLATE PARA PREGUNTAS DE TIPO CAMPOS -->

                      <!-- TEMPLATE PARA PREGUNTAS DE TIPO GRUPO_REPETIBLE -->
                      <div v-else-if="one_question.tipo === 'GRUPO_REPETIBLE'">
                        <div v-for="(group, groupIndex) in one_question.respuesta" :key="'group_' + groupIndex" class="mb-4 p-4 border border-gray-300 rounded bg-gray-50">
                          <div class="font-bold text-gray-600 mb-2 text-sm">Registro {{ groupIndex + 1 }}</div>
                          <template
                            v-for="(val, label) in group"
                          >
                            <div class="flex w-full items-center justify-center">
                              <label
                                class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                                >{{ label }}</label
                              >
                              <input
                                class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                type="text"
                                :value="Array.isArray(val) ? val.join(', ') : val"
                                disabled
                              />
                            </div>
                          </template>
                        </div>
                      </div>
                      <!-- /TEMPLATE PARA PREGUNTAS DE TIPO GRUPO_REPETIBLE -->

                      <!-- TEMPLATE PARA PREGUNTAS DE TIPO OPCION_SEGUIMIENTO -->
                      <div v-else-if="one_question.tipo === 'OPCION_SEGUIMIENTO'">
                        <div v-for="(ans, idx) in one_question.respuesta" :key="'ans_' + idx" class="mb-4">
                          <p class="font-bold text-gray-700 text-sm mb-2">{{ ans.concepto }}</p>
                          <div class="flex w-full items-center justify-center">
                            <label class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left">Respuesta</label>
                            <input
                              class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              type="text"
                              :value="ans.selected_answer"
                              disabled
                            />
                          </div>
                          <div v-if="ans.sub_respuesta && ans.sub_respuesta !== '' && !(Array.isArray(ans.sub_respuesta) && ans.sub_respuesta.length === 0)">
                            <div class="flex w-full items-center justify-center">
                              <label class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left">Detalle</label>
                              <input
                                class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                type="text"
                                :value="Array.isArray(ans.sub_respuesta) ? ans.sub_respuesta.join(', ') : ans.sub_respuesta"
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- /TEMPLATE PARA PREGUNTAS DE TIPO OPCION_SEGUIMIENTO -->

                      <div v-else>
                        Ninguna de las anteriores
                      </div>
                    </div>
                  </div>
                  <!-- /Ficha de información-->
                </div>
                
              </div>

              <div
                class="flex w-full sticky bottom-0 justify-end py-5 bg-white"
              >
                <!--                 <button
                  v-if="showFormView || showMultimediaView"
                  class="ml-2 bg-red-500 hover:bg-red-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="backView()"
                >
                  Atrás
                </button>
                <button
                  v-if="showCategoriesView || showFormView"
                  class="ml-2 bg-blue-500 hover:bg-blue-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="showMultimediaForm()"
                >
                  Subir foto o video
                </button>
                <button
                  v-if="showCategoriesView || showMultimediaView"
                  class="ml-2 bg-green-500 hover:bg-green-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="showLevantamientoForm()"
                >
                  Llenar ficha
                </button> -->
                <button
                  v-if="showFormView"
                  class="ml-2 bg-purple-500 hover:bg-purple-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="close()"
                >
                  Cerrar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <alert-dialog :showing="showingSuccess">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          Levantamiento guardado correctamente
        </div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full" v-if="answers.length === 0">
        <span class="text-sm tracking-wide text-purple-500"
          >Es necesario llenar la ficha del levantamiento</span
        >
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="close()"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>
    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Ha ocurrido un error.</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-cdmx-red"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>
  </div>
</template>
<script>
import urlMixin from "@/mixins/urlMixin";
import config from "../../vue.config.js";

import AlertDialog from "./AlertDialog";

import moment from "moment";


export default {
  mixins: [urlMixin],
  data() {
    return {
      fileMimeType: null,
      categorySelected: null,
      categories: [],
      subcategorySelected: null,
      subcategories: [],
      nameLevantamiento: null,
      showCategoriesView: false,
      showMultimediaView: false,
      showFormView: true,
      questions: [],
      answers: [],
      inputFilePlaceholder: "Sin archivos seleccionados",
      levantamientoMediaUrl: null,
      imageSelected: false,
      videoSelected: false,
      currentQuestions: [],
      user_id: localStorage.getItem("user_id"),
      category_id: window.atob(localStorage.getItem("category")),
      errors: {
        selectCategory: false,
        selectSubcategory: false,
        name: false,
        file_extension: false,
        codeError: "Ha ocurrido un error",
      },
      showingSuccess: false,
      showingError: false,
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
        },
      },
      mediaArray: [],
      currentMediaIndex: 0,
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean,
    },
    levantamientoInfo: {
      required: true,
      type: Object,
    },
  },
  watch: {
    showing(value) {
      // removed console log
      if (value) {
        // removed console log
        //this.fetchQuestions();
        this.currentQuestions = [];
        this.fetchAnswers();
        if (this.levantamientoInfo.ubicacion_sensible) {
          this.mediaArray = JSON.parse(this.levantamientoInfo.media_array);
        }
        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden");
    },
  },
  mounted() {
    // removed console log
    this.fetchCategories();
  },
  components: {
    AlertDialog,
  },
  methods: {
    reset: function () {
      this.fileMimeType = null;
      this.categorySelected = null;
      this.subcategorySelected = null;
      this.subcategories = [];
      this.nameLevantamiento = null;
      this.showCategoriesView = false;
      this.showMultimediaView = false;
      this.showFormView = true;
      this.questions = [];
      this.answers = [];
      this.imageSelected = false;
      this.videoSelected = false;
      this.inputFilePlaceholder = "Sin archivos seleccionados";
      this.errors = {
        selectCategory: false,
        selectSubcategory: false,
        name: false,
        file_extension: false,
        codeError: "Ha ocurrido un error",
      };
      this.showingSuccess = false;
      this.showingError = false;
      this.mediaArray = [];
      this.currentMediaIndex = 0;
    },
    close() {
      this.reset();
      this.$emit("close");
    },
    fetchCategories() {
      // removed console log
      this.axios
        .get("../apidev/categories/catprinc/getMainCategories", this.config)
        .then((response) => {
          this.categories = response.data.categorias;
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    fetchSubcategories() {
      this.axios
        .post(
          "../apidev/categories/subcategorias/getSubcategories",
          {
            id_maincategory: this.categorySelected,
          },
          this.config
        )
        .then((response) => {
          this.subcategories = response.data.subcategorias;
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    fetchQuestions() {
      this.axios
        .post(
          "../apidev/levantamientos/getFichaPreguntas",
          {
            id_cat_principal: this.levantamientoInfo.id_cat_principal,
            id_cat_secundaria: this.levantamientoInfo.id_cat_secundaria,
          },
          this.config
        )
        .then((response) => {
          // removed console log
          this.questions = response.data.questions;
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    fetchAnswers() {
      // removed console log
      this.axios
        .post(
          "../apidev/levantamientos/getFichaRespuestasJson",
          {
            id_levantamiento: this.levantamientoInfo.id,
          },
          this.config
        )
        .then((response) => {
          // removed console log
          this.currentQuestions = response.data.answers;
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },

    showMultimediaForm() {
      if (this.showCategoriesView) {
        const form = document.getElementById("levantamientoForm");
        const formData = new FormData(form);
        const validForm = this.validateForm(formData);

        if (validForm) {
          this.showCategoriesView = false;
          this.showFormView = false;
          this.showMultimediaView = true;
        }
      } else {
        this.showCategoriesView = false;
        this.showFormView = false;
        this.showMultimediaView = true;
      }
    },
    showLevantamientoForm() {
      if (this.showCategoriesView) {
        const form = document.getElementById("levantamientoForm");
        const formData = new FormData(form);
        const validForm = this.validateForm(formData);

        if (validForm) {
          this.showCategoriesView = false;
          this.showMultimediaView = false;
          this.showFormView = true;
        }
      } else {
        this.showCategoriesView = false;
        this.showMultimediaView = false;
        this.showFormView = true;
      }
    },
    saveLevantamiento() {
      let request = {};
      if (this.answers.length > 0) {
        let userAnswers = [];
        this.questions.forEach((question, index) => {
          let userAnswer = {
            id: question.id_pregunta,
            answer: this.answers[index],
          };

          userAnswers.push(userAnswer);
        });

        request = {
          id_cat_principal: this.categorySelected,
          id_cat_secundaria: this.subcategorySelected,
          id_usuario: localStorage.getItem("user_id"),
          nombre: this.nameLevantamiento,
          registro: null,
          respuestas: userAnswers,
          multimedia: null,
          fecha_levantamiento: new Date(),
          geometry: {},
          fuente: "web",
          latitud: this.latitud,
          longitud: this.longitud,
        };
      } else {
        request = {
          id_cat_principal: this.categorySelected,
          id_cat_secundaria: this.subcategorySelected,
          id_usuario: localStorage.getItem("user_id"),
          nombre: this.nameLevantamiento,
          registro: null,
          respuestas: null,
          multimedia: null,
          fecha_levantamiento: new Date(),
          geometry: {},
          fuente: "web",
          latitud: this.latitud,
          longitud: this.longitud,
        };
      }

      this.axios
        .post("../apidev/levantamientos/newLevantamiento", request, this.config)
        .then((response) => {
          if (document.getElementById("levantamientoFile").value !== "") {
            const form = document.getElementById("levantamientoForm");
            const formMediaData = new FormData(form);
            const levantamientoFile = formMediaData.get("levantamientoFile");
            // const mediaFilename =
            //   localStorage.getItem("user_id") + "_" + this.inputFilePlaceholder;
            const newDate = new Date();
            const mediaFilename =
              localStorage.getItem("user_id") +
              "_" +
              newDate.getTime() +
              this.fileMimeType;

            let levantamientoId = response.data.levantamiento_id;

            const formData = new FormData();
            formData.append("id", levantamientoId);
            formData.append(
              "levantamientoFile",
              levantamientoFile,
              mediaFilename
            );

            this.axios
              .post("../apidev/levantamientos/media", formData, this.config)
              .then((response) => {
                // removed console log
                this.showingSuccess = true;
              })
              .catch((error) => {
                if (
                  error.response.status == 400 ||
                  error.response.status == 401
                ) {
                  if (
                    error.response.data.name === "TokenExpiredError" ||
                    error.response.data.name === "InvalidTokenError" ||
                    error.response.data.name === "JsonWebTokenError"
                  ) {
                    this.$router.push({ path: "/login" });
                  }
                }
              });
          } else {
            this.showingSuccess = true;
          }
        })
        .catch((error) => {
          // removed console log
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    joinCategories(opciones) {
      let string_categories = "";
      for (const property in opciones) {
        if (opciones[property]) {
          string_categories += property + ", ";
        }
      }

      return string_categories;
    },
    backView() {
      this.showFormView = false;
      this.showMultimediaView = false;
      this.showCategoriesView = true;
    },
    validateForm(data) {
      if (data.get("selectCategory") === null) {
        this.errors.selectCategory = true;
      } else {
        this.errors.selectCategory = false;
      }

      if (data.get("selectSubcategory") === null) {
        this.errors.selectSubcategory = true;
      } else {
        this.errors.selectSubcategory = false;
      }

      if (data.get("name") === "") {
        this.errors.name = true;
      } else {
        this.errors.name = false;
      }

      if (
        this.errors.selectCategory ||
        this.errors.selectSubcategory ||
        this.errors.name
      ) {
        return false;
      }

      return true;
    },
    changeLevantamientoFile(event) {
      const file = event.target.files[0];
      this.inputFilePlaceholder = file.name;
      const fileMimeType = this.checkMimeType(file);

      if (fileMimeType === "") {
        this.errors.file_extension = true;
        this.levantamientoMediaUrl = this.srcUrl + "/null";
      } else {
        if (fileMimeType === ".mp4") {
          this.errors.file_extension = false;
          this.levantamientoVideoUrl = URL.createObjectURL(file);
          this.videoSelected = true;
          this.imageSelected = false;
        } else {
          let image = new Image();
          image.src = URL.createObjectURL(file);
          image.onload = () => {
            this.errors.file_extension = false;
            this.levantamientoImageUrl = URL.createObjectURL(file);
            this.imageSelected = true;
            this.videoSelected = false;
          };
        }
      }
      this.fileMimeType = fileMimeType;
    },
    checkMimeType(file) {
      let mimeType = "";
      switch (file.type) {
        case "image/jpeg":
          mimeType = ".jpeg";
          break;
        case "image/png":
          mimeType = ".png";
          break;
        case "image/jpg":
          mimeType = ".jpg";
          break;
        case "video/mp4":
          mimeType = ".mp4";
          break;
        default:
          mimeType = "";
          break;
      }
      return mimeType;
    },

    slideToLeft() {
      if (this.currentMediaIndex > 0) {
        this.currentMediaIndex -= 1;
      } else {
        this.currentMediaIndex = this.mediaArray.length - 1;
      }
      let nextMedia = this.mediaArray[this.currentMediaIndex];

      if (nextMedia.mimeType.includes("image")) {
        let image = document.getElementById("imageLev");
        image.src = `../apidev/${nextMedia.fileName}`;
      } else {
        let video = document.getElementById("videoLev");
        video.src = `../apidev/${nextMedia.fileName}`;
      }
    },
    slideToRight() {
      if (this.currentMediaIndex < this.mediaArray.length - 1) {
        this.currentMediaIndex += 1;
      } else {
        this.currentMediaIndex = 0;
      }
      let nextMedia = this.mediaArray[this.currentMediaIndex];

      if (nextMedia.mimeType.includes("image")) {
        let image = document.getElementById("imageLev");
        image.src = `../apidev/${nextMedia.fileName}`;
      } else {
        let video = document.getElementById("videoLev");
        video.src = `../apidev/${nextMedia.fileName}`;
      }
    },
  },
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
textarea {
  resize: none;
}

.textareaficha {
  resize: vertical; 
  text-align:justify; 
  height:auto;
}
</style>
